import { useContext, useMemo } from 'react';
import { UnicornApiContext } from './UnicornApi.context';
import { createUseUnicornTreatment, UnicornApi } from '@cld/unicorn-api';

const VIDEO_APP_NOT_ALLOWED_ROLES = ['reports', 'billing'];

// fake method added to avoid using hook conditionally
// casting to 'any' to always resolve promise with 'off' state instead of keeping treatment in loading state
const fakeCreateUseUnicornTreatment: UnicornApi['methods']['getAbTestTreatment'] = () => Promise.resolve('off' as any);

export const useVideoAppAccess = (defaultValue: boolean) => {
  const { unicornApi } = useContext(UnicornApiContext);
  const isUnicornApiAvailable = !!unicornApi?.methods.getAbTestTreatment;
  const useUnicornTreatment = useMemo(
    () => createUseUnicornTreatment(isUnicornApiAvailable ? unicornApi.methods.getAbTestTreatment : fakeCreateUseUnicornTreatment),
    [unicornApi]
  );
  const videoAppGlobalAccess = unicornApi?.data.user.role ? !VIDEO_APP_NOT_ALLOWED_ROLES.includes(unicornApi.data.user.role) : true;
  const videoAppAccountFlag = unicornApi?.data.capabilities.includes('newVideoApp') ?? false;
  const treatment = useUnicornTreatment({
    assignedTo: 'account',
    testId: 'New-Video-Application',
    supportedTreatments: ['on', 'off'],
    errorFallbackTreatment: 'off',
    attributes: {
      plan_name: unicornApi?.data.plan.name || 'unknown',
      video_app_account_flag: videoAppAccountFlag,
    },
  });

  if (!isUnicornApiAvailable) {
    return defaultValue;
  }

  return videoAppGlobalAccess && videoAppAccountFlag && treatment === 'on';
};
